import { createJSONRequest } from './create-request'

export const fetchInnovationRadarQuarters = () => createJSONRequest({
  url: '/api/innovation-radar-reports',
  method: 'GET',
})

export const fetchInnovationRadar = (id: Number) => createJSONRequest({
  url: `/api/innovation-radar-reports/${id}`,
  method: 'GET',
})
